import { useQuery } from 'react-query';

import { TableUsageData } from '../../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

const useGetUsageDataByMatter = (
  enabled: boolean,
  startDate: string,
  endDate: string,
  matterId?: string,
  userId?: string,
  orgId?: string,
  billableOnly?: boolean,
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<TableUsageData>(
    [QueryEntity.OrgUsageData, 'matter', startDate, endDate, matterId, userId, orgId, billableOnly],
    () => {
      const url = new URL(`${APIBaseChronos}/api/org/usage-data/matter`);
      url.searchParams.append('start', startDate);
      url.searchParams.append('end', endDate);
      if (matterId) url.searchParams.append('matterId', matterId);
      if (userId) url.searchParams.append('userId', userId);
      if (orgId) url.searchParams.append('orgId', orgId);
      if (billableOnly) url.searchParams.append('billableOnly', 'true');

      return fetch(url.toString(), {
        ...fetchConfigGET,
        method: FetchMethod.GET,
      })
        .then((res) => res.json())
        .catch((err) => {
          console.error(err);
        });
    },
    {
      enabled,
      refetchOnWindowFocus: false,
    },
  );
};

export default useGetUsageDataByMatter;
